
        import CodeMirror from 'codemirror';
        import 'codemirror/mode/xml/xml';
        import 'codemirror/mode/javascript/javascript';
        import 'codemirror/mode/css/css';
        import 'codemirror/mode/htmlmixed/htmlmixed';
        import 'codemirror/addon/fold/xml-fold';
        import 'codemirror/addon/fold/foldcode';
        import 'codemirror/addon/fold/foldgutter';
        import 'codemirror/addon/fold/brace-fold';
        import 'codemirror/addon/fold/comment-fold';
        import 'codemirror/addon/edit/closebrackets';
        import 'codemirror/addon/edit/matchtags';
        import 'codemirror/addon/edit/matchbrackets';
        import 'codemirror/addon/hint/show-hint';
        import 'codemirror/addon/hint/html-hint';
        import 'codemirror/addon/hint/xml-hint';
        import 'codemirror/addon/display/placeholder';

        window.CodeMirror = CodeMirror;
    